import { FC } from 'react'
import { Container, ContainerLarge } from '../../container'
import { TimelineVideo } from '../video'
import { ReadMore } from '../../read-more'
import {
  TimelineTitle,
  TimelineTitleMask,
  TimelineIntro,
  TimelineSubtitle,
  TimelineContent,
  TimelineImage,
  TimelineAnchor,
} from '../styled'
import { texts } from '../../locale'
type Props = {
  scrollUp: boolean
}
export const Chapter_9: FC<Props> = ({ scrollUp }) => {
  return (
    <>
      <TimelineTitle>
        <TimelineAnchor id="chapter-9" $scrollUp={scrollUp} />
        <TimelineTitleMask />
        <img
          src={
            'https://gdb.rferl.org/01000000-0aff-0242-f9a4-08db4ad2500e_w1920_r4.jpg'
          }
        />
        <h2>
          <span>9</span>
          Авдіївка. Загострення по всьому фронту
          <strong>{texts.menu_18}</strong>
        </h2>
      </TimelineTitle>

      <ContainerLarge>
        <TimelineIntro>
          Цей етап характеризувався періодичними послабленнями і посиленнями
          наступів Росії на ключових напрямках, проте, головною точкою, на якій
          агресор зосередив свій тиск, стала саме Авдіївка. Олександр Сирський,
          на той момент командувач Сухопутних військ ЗСУ, на початку осені
          2023-го заявив, що Росія готується до реваншу на Сході. Так і сталось:
          агресор поступово посилив тиск практично на усіх напрямках:
          Куп’янсько-Лиманському; Бахмутському; Авдіївському, а також на
          Запоріжжі – під Роботиним. Лише на одній ділянці фронту продовжилось
          відносне затишшя (з обстрілами і штурмами, проте без стягування сил і
          успіхів противника) – це Вугледар-Велика Новосілка на півдні
          Донеччини. Проте, варто уявляти реальну картину на місцевості: усі
          просування, яких військам РФ вдалось досягти за цей період війни,
          стосувалися відстаней від сотень метрів (Куп'янський, Бахмутський,
          Роботинський напрями) – до десятка кілометрів у випадку з Авдіївкою.
          Тоді як витрати техніки й живої сили на них, за висновками аналітиків,
          у Кремля були величезними.
        </TimelineIntro>

        <TimelineContent>
          <TimelineSubtitle>вересень</TimelineSubtitle>
          <p>
            Російські війська перекидають на Лиманський напрямок частини
            новоствореної 25 загальновійськової армії РФ. Аналітики вважають, що
            Росія прагне вдруге захопити місто (або принаймні вийти на лівий
            берег річки Оскіл, щоб зайняти плацдарм для подальшого форсування).
            Куп’янськ є важливим логістичним вузлом, який дозволив би агресору
            розвивати наступ на вільний Донбас і за бажання – на Харків. Саме
            тоді командувач Сухопутних військ заявив про плани російського
            реваншу на східному фронті.
          </p>

          <TimelineSubtitle>10 жовтня</TimelineSubtitle>
          <p>
            Росія переходить у потужний наступ на Авдіївському напрямку. Заяви
            російської пропаганди у той день свідчили, що РФ розраховувала
            захопити Авдіївку вже до вечора. Протягом наступних 4-х місяців
            війська РФ щодня проводили на напрямку по 20-60 штурмів і взяли
            місто лише в середині лютого 2024 року.
          </p>

          <ReadMore>
            <p>
              Українські військові та міжнародні монітори, як от Institute of
              Study of War та Британська розвідка, констатували: Росія задіяла в
              операції із взяття Авдіївки безпрецедентну кількість військ (за
              даними Британської розвідки – 8 бригад). Вже наприкінці жовтня
              британці назвали російські втрати під Авдіївкою одними з
              найбільших за 2023 рік, а за перший місяць посилених штурмів РФ
              втратила на напрямку 10 тисяч військових і 350 одиниць
              бронетехніки за підрахунками Генштабу ЗСУ. Росії не вдався
              авдіївський бліцкриг за день, але значна кількість задіяних сил
              дозволила їй звужувати кільце навколо міста впродовж наступних
              чотирьох місяців. Російські підрозділи йшли на Авдіївку
              бронеколонами із десантом, втрачаючи їх у полях. Ось як виглядали
              типові російські штурми там:
            </p>
            <TimelineVideo id={'0a_xG3uNb_Y'} />
          </ReadMore>

          <TimelineSubtitle>листопад</TimelineSubtitle>
          <p>
            Армія РФ активізувалася на Бахмутському напрямку: спершу перейшла в
            атаку на північно-західному фланзі, саме там, де Україні вдалося
            досягти значних успіхів під час літнього наступу. А згодом розпочала
            спроби відтісняти українських бійців і на півдні: в районі опорної
            для обох сторін Кліщіївки.
          </p>
          <TimelineVideo id={'9HS3YhtiFMo'} />

          <TimelineSubtitle>січень 2024</TimelineSubtitle>
          <p>
            На Лимансько-Куп’янському фронті російська армія захоплює руїни села
            Крохмальне та пробує зайти у село Табаївка, де втім не може
            закріпитися. Таким чином, попри періодичні успіхи вздовж лінії
            Лиман-Куп'янськ, російській армії вдалося за осінь-зиму захопити
            повністю лише один населений пункт. Однією з найважчих точок тут є
            Серебрянський ліс, де війська Росії тиснуть на ЗСУ від моменту, коли
            захопили Кремінну.
          </p>
          <TimelineVideo id={'bhW0u0DF6ZU'} />

          <TimelineSubtitle>лютий</TimelineSubtitle>
          <p>
            Російські війська досягають просувань на двох напрямках під
            Бахмутом: біля Богданівки та Кліщіївки. Перше створює небезпеку для
            міста Часів Яр. Друге дозволило агресору наблизитися до панівної
            висоти, котра дає перевагу в бойових діях, – проте, так і не взяти
            її.
          </p>

          <p>
            Біля Куп’янська на кінець лютого основними точками, які прагне
            пройти російська армія на шляху до річки Оскіл, є села Синьківка,
            Торське та Серебрянське лісництво. Проте просування коливаються у
            межах сотень метрів полів і посадок.
          </p>

          <p>
            Триває штурм Авдіївки. Окрім звуження кліщів навколо міста (це
            штурми сіл Первомайське, Невельське, Степове, Бердичі,
            Новобахмутівка та інших) російські війська змогли пробитися до
            міської забудови та почати безпосередню атаку міста.
          </p>

          <TimelineSubtitle>17 лютого</TimelineSubtitle>
          <p className="last_paragraph">
            Українські війська виходять з Авдіївки. В останні дні боротьби за
            місто оборонці проривались з локальних оточень. За оцінками 3
            окремої штурмової бригади, що була відряджена до Авдіївки на
            підсилення, проти ЗСУ там стояли 7 бригад ЗС РФ, українські бійці на
            деяких ділянках воювали на 360°. За оцінками військових аналітиків,
            Росія дотисла Авдіївку надактивним застосуванням керованих авіабомб
            (до 40-60 ФАБ на добу) та великих піхотних сил. Сумарні втрати Росії
            за взяття Авдіївки Британська розвідка попередньо оцінила у десятки
            тисяч особового складу і 400 одиниць бронетехніки, Генштаб – у 47
            тисяч особового складу та понад 1100 одиниць техніки.
          </p>
        </TimelineContent>
      </ContainerLarge>
    </>
  )
}
